var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_reset-user-data_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Robotics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,10,5.55,10c1.88-3,5.6-5.62,9.43-5.62a10.66,10.66,0,0,1,10.25,7.77,5.91,5.91,0,0,1,2.66,1.32A13,13,0,0,0,15,2C10.81,2,6.13,4.34,4,8.07L4,4H2v8h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,17.5A3.5,3.5,0,1,0,23.49,14,3.5,3.5,0,0,0,20,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,22H21a3.21,3.21,0,0,0-3,3.37V30H29V25.37A3.2,3.2,0,0,0,26,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.41,16.18H2A13,13,0,0,0,15,28c.34,0,.67,0,1,0V25.58c-.33,0-.66.06-1,.06A10.64,10.64,0,0,1,4.41,16.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.eccd3b5606659c9f45e89fdc413348fd.svg";
export { ForwardRef as ReactComponent };